import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/site/Seo";

const LINKS = [
  ["/", "Home"], ["/procurement", "Procurement & Sourcing"], ["/industrial-mro", "Industrial & MRO"],
  ["/government", "Government Contracting & Capabilities"], ["/contact", "Contact"], ["/request-a-quote", "Submit an RFQ"],
];

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <Seo title="Page Not Found" description="The page you requested could not be found." path="/404" noindex />
      <section className="pt-[150px] pb-24 bg-[var(--pg-bg)] min-h-[70vh]">
        <div className="pg-container max-w-3xl">
          <span className="eyebrow">404 — Page Not Found</span>
          <h1 className="mt-5 text-[36px] md:text-[50px] font-extrabold leading-[1.06] text-[var(--pg-navy)]">We couldn't find that page.</h1>
          <p className="mt-5 text-[16.5px] text-[var(--pg-ink-soft)] leading-relaxed">
            The link may be outdated or the address mistyped. Here are the pages buyers use most:
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {LINKS.map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`notfound-link-${to === "/" ? "home" : to.slice(1)}`} className="flex items-center justify-between bg-white border border-slate-200 rounded-xl px-5 py-4 font-[Poppins] font-semibold text-[14.5px] text-[var(--pg-navy)] hover:border-[var(--pg-accent)] hover:text-[var(--pg-accent)] transition-colors">
                  {label} <ArrowRight size={16} />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
